import { render, staticRenderFns } from "./EditButtons.vue?vue&type=template&id=419addf7&"
import script from "./EditButtons.vue?vue&type=script&lang=js&"
export * from "./EditButtons.vue?vue&type=script&lang=js&"
import style0 from "./EditButtons.vue?vue&type=style&index=0&id=419addf7&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports